import { render, staticRenderFns } from "./FSWView.vue?vue&type=template&id=1115de96&scoped=true"
import script from "./FSWView.vue?vue&type=script&lang=js"
export * from "./FSWView.vue?vue&type=script&lang=js"
import style0 from "./FSWView.vue?vue&type=style&index=0&id=1115de96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1115de96",
  null
  
)

export default component.exports